(() => {
  // Inbox exposes the same activator part before and after its runtime loads.
  // Keep this adapter scoped to its element; do not depend on an undocumented API.
  function findInChat(selector) {
    const host = document.querySelector('shopify-chat');
    if (!host) return null;
    const roots = [host];
    while (roots.length) {
      const root = roots.shift();
      const match = root.querySelector(selector);
      if (match) return match;
      if (root.shadowRoot) roots.push(root.shadowRoot);
      root.querySelectorAll('*').forEach(element => {
        if (element.shadowRoot) roots.push(element.shadowRoot);
      });
    }
    return null;
  }

  function chatIsOpen() {
    return findInChat('button[part~="activator"]')?.getAttribute('aria-expanded') === 'true';
  }

  const pause = ms => new Promise(resolve => setTimeout(resolve, ms));

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-astra-chat]');
    if (!button || button.disabled) return;
    const label = button.querySelector('[data-astra-chat-label]');
    const originalLabel = label.textContent;
    const fallback = button.closest('.astra-chat-help').querySelector('[data-astra-chat-fallback]');
    fallback.hidden = true;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = button.dataset.loadingLabel;
    let opened = false;

    try {
      const deadline = Date.now() + 6000;
      let activator;
      do {
        activator = findInChat('button[part~="activator"]');
        if (activator) break;
        await pause(100);
      } while (Date.now() < deadline);

      if (activator) {
        const sizeDialog = button.closest('dialog.astra-size-dialog[open]');
        if (sizeDialog) {
          sizeDialog.close();
          // Let the size guide restore focus before moving it to the chat.
          await pause(50);
        }
        if (!chatIsOpen()) activator.click();
        for (let attempt = 0; attempt < 20; attempt++) {
          if (chatIsOpen()) {
            opened = true;
            findInChat('[part~="dialog"][role="dialog"]')?.focus();
            break;
          }
          await pause(100);
        }
        if (!opened && sizeDialog) sizeDialog.showModal();
      }
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
      label.textContent = originalLabel;
      fallback.hidden = opened;
    }
  });
})();
